import { Serializer } from 'jsonapi-serializer'

export default new Serializer('tour_user', {
  attributes: ['name']
})
